import { GamePage } from '@/pages/Game'
import { TutorialPage } from '@/pages/Tutorial'

function App() {
  return new URLSearchParams(window.location.search).has('tutorial') ? <TutorialPage /> : <GamePage />
}

export default App
